import { useEffect } from 'react';
export const useKeyDown = (callback: (e: KeyboardEvent) => void, keys: 'Escape'[]) => {
    const onKeyDown = (event: KeyboardEvent) => {
        const wasAnyKeyPressed = keys.some((key) => event.key === key);
        if(wasAnyKeyPressed) {
            event.preventDefault();

            callback(event);
        }
    };
    useEffect(() => {
        document.addEventListener('keydown', onKeyDown);
        return () => {
            document.removeEventListener('keydown', onKeyDown);
        };
    }, [onKeyDown]);
};